import { SkillsContent } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/block_schema_pb'
import { useRef, useState } from 'react'

import { Badge } from '@/components/ui/badge'
import {
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { ResponsiveSheet } from '@/components/ui/responsive-sheet'
import { ResponsiveSheetContent } from '@/components/ui/responsive-sheet-content'

import { BlockProps } from '../shared/block-switch'
import { SkillInner } from './skills-inner'

export const SkillsBlock = ({ block, h, w, scaleFactor }: BlockProps) => {
  const [open, setOpen] = useState(false)
  const content = block?.content?.content?.value as SkillsContent
  const containerRef = useRef<HTMLDivElement>(null)

  const title = content?.title
  const items = (content?.skills || []).filter((item) => !!item?.title)

  return (
    <ResponsiveSheet open={open} onOpenChange={setOpen}>
      <DialogTrigger className="cursor-pointer p-block flex size-full flex-col outline-hidden! text-left">
        <SkillInner
          items={items}
          title={title}
          h={h}
          w={w}
          scaleFactor={scaleFactor}
        />
      </DialogTrigger>

      <ResponsiveSheetContent className="max-h-[calc(100vh-100px)] overflow-y-auto font-page-body font-page-body-weight">
        {title && (
          <DialogHeader>
            <DialogTitle className="font-page-heading font-page-heading-weight! text-2xl!">
              {content?.title}
            </DialogTitle>
          </DialogHeader>
        )}

        <div className="flex-1 pt-2">
          <div className="flex flex-wrap gap-1.5" ref={containerRef}>
            {items.map((item, index) => (
              <Badge key={index} className="text-sm!">
                <div className="line-clamp-1">{item.title}</div>
              </Badge>
            ))}
          </div>
        </div>
      </ResponsiveSheetContent>
    </ResponsiveSheet>
  )
}
